import { Popover as MuiPopover } from "@mui/material";
import { styled } from "@mui/material/styles";

const Popover = styled(MuiPopover)(({ styles }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "var(--container-light)",
  },

  ...styles,
}));

export default Popover;
